const Button = ({
  primary = false,
  small = false,
  href,
  onClick,
  className = "",
  children,
}) => {
  const Tag = href ? "a" : "button";
  return (
    <Tag
      href={href}
      onClick={onClick}
      className={`${className} inline-flex items-center justify-center text-base font-medium rounded-md
                       active:shadow-inner border border-transparent focus:outline-none focus:ring-2
                       focus:ring-offset-2 focus:ring-primary-500
                       ${
                         primary
                           ? "text-white bg-gradient-to-br from-green-600 to-primary-600 hover:from-green-700 hover:to-primary-700"
                           : "border-gray-300 text-gray-700 bg-white hover:bg-gray-50"
                       }
                       ${small ? "px-4 py-2 shadow-sm" : "px-5 py-3 shadow-md"}
                `}
    >
      {children}
    </Tag>
  );
};

export default Button;
